import eventHandler, { EventName } from '../eventHandler';
import { Metadata, MetadataCollector } from './metadata';

export default class EventMetadataCollector implements MetadataCollector {
  updateMetadata(metadata: Metadata): void {
    eventHandler.emitEvent<Metadata>(EventName.addMetadata, metadata);
  }
}
